import { useState } from "react";
import { Check, ChevronsUpDown, GitBranch, Layers } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { useBranches, STATUS_LABEL } from "@/lib/branch";

export const BranchSelector = () => {
  const ctx = useBranches();
  const [open, setOpen] = useState(false);
  if (!ctx || ctx.branches.length === 0) return null;
  const { branches, selected, current, setSelected } = ctx;
  const pick = (id) => { setSelected(id); setOpen(false); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-white border border-[#FECACA] text-sm text-[#7F1D1D] hover:border-[#DC2626] transition-colors max-w-full" data-testid="branch-selector-trigger">
          {current ? <GitBranch className="w-4 h-4 text-[#DC2626]" /> : <Layers className="w-4 h-4 text-[#DC2626]" />}
          <span className="truncate"><span className="text-[#94A3B8] mr-1">Branch:</span><b>{current ? `${current.referral_code} — ${current.name}` : "All Branches"}</b></span>
          <ChevronsUpDown className="w-4 h-4 text-[#94A3B8]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="end">
        <Command>
          <CommandInput placeholder="Search branch…" data-testid="branch-selector-search" />
          <CommandList>
            <CommandEmpty>No branch found.</CommandEmpty>
            <CommandGroup>
              <CommandItem onSelect={() => pick("all")} data-testid="branch-option-all">
                <Layers className="w-4 h-4 mr-2" /> All Branches — Combined View
                {selected === "all" && <Check className="w-4 h-4 ml-auto" />}
              </CommandItem>
              {branches.filter((b) => b.status !== "cancelled").map((b) => (
                <CommandItem key={b.id} value={`${b.referral_code} ${b.name}`} onSelect={() => pick(b.id)} data-testid={`branch-option-${b.referral_code}`}>
                  <div className="flex flex-col">
                    <span className="font-medium">{b.referral_code} — {b.name}</span>
                    <span className="text-[11px] text-[#94A3B8]">{b.branch_code} · {STATUS_LABEL[b.status]}</span>
                  </div>
                  {selected === b.id && <Check className="w-4 h-4 ml-auto" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
